import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import AllItems from "../../components/user/item/AllItems";
import { useItemContext } from "../../context/item_context";
import AllServices from "../../components/user/service/AllServices";


function Item() {

  const {
    type, changeType,
  } = useItemContext();

  return (
    <>
      <AppWrapper
        pagename={"inventory"}
      >

        {/* Select buttons for Services or Item */}

        <div
          className="d-flex transparent py-2 px-2 br-sm fit-content mx-auto mt-4 justify-content-between pry-border">
          <div
            className={`col br-sm py-1 pry-bold-text pointer text-center px-3 ${ type === 'item' ? 'pry-bold light-text ' : ('') } `}
            onClick={e => changeType('item')}
          >
            Items
          </div>
          <div
            className={`col br-sm py-1 pry-bold-text pointer text-center px-3 ${ type === 'service' ? 'pry-bold light-text' : ('') } `}
            onClick={e => changeType('service')}
          >
            Services
          </div>
        </div>

        <StyledItem>
          {/* <Title title={type} btnName={""} /> */}
        </StyledItem>


        {type === 'item' ?
          <AllItems /> :
          <AllServices />
        }


      </AppWrapper>

    </>
  );
}

export default Item;

const StyledItem = styled.div`

`;